import { Descriptions } from "antd";
import styled from "styled-components";

const formatWidth = (width) =>
  typeof width === "number" ? `${width}px` : width;

export const Description = styled(Descriptions)`
  &.ant-descriptions {
    padding-right: 20px;
    min-width: ${({ $width }) => formatWidth($width)};
    width: ${({ $width }) => formatWidth($width)};
  }

  .ant-descriptions-header {
    margin-bottom: 10px;
  }

  .ant-descriptions-item-label {
    color: #747476;
    font-size: 14px;
  }

  th.ant-descriptions-item {
    padding: 0;
  }

  .ant-descriptions-item {
    padding-bottom: 12px;
    margin-right: 12px;
  }

  .ant-descriptions-item-content {
    font-size: 16px;
  }
`;
